//auth
export const OKINUS_CUSTOMER_PORTAL = "myokinus.com";
export const BREEZE_CUSTOMER_PORTAL = "mybreezelease.com";

